// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"ConfigureDialog_itemWrapper__4cGCe","rowWrapper":"ConfigureDialog_rowWrapper__2lPXY"};